// MSAL Configuration for Microsoft Entra ID SSO
export const msalConfig = {
  auth: {
    clientId: "4426075e-fe72-45cd-899f-48cdd5744355",
    authority: "https://login.microsoftonline.com/2da0b43a-b8f0-45ed-8716-4fdeecec40fe",
    redirectUri: window.location.origin + "/",
    postLogoutRedirectUri: window.location.origin + "/",
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    allowNativeBroker: false,
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
  },
};

export const loginRequest = {
  scopes: [
    "openid", 
    "profile", 
    "email", 
    "User.Read",
    "https://management.azure.com/user_impersonation"  // Azure Management API for cost data
  ],
  prompt: "select_account", // Always show account picker
};

export const tokenRequest = {
  scopes: ["User.Read"],
};

// Azure Management API scopes for cost data
export const azureManagementRequest = {
  scopes: ["https://management.azure.com/user_impersonation"],
};

// Microsoft Graph API scopes for tenant/licensing data
export const graphApiRequest = {
  scopes: [
    "User.Read",
    "Directory.Read.All",
    "Organization.Read.All",
  ],
};
